module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_2.80b81ca5.png";